import Dashboard from '@/dashboard/page'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/dashboard')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Dashboard></Dashboard>
  )
}
